import { FC } from "react";
import SearchFieldBar from "componentLayout/Header/HeaderFour/HeaderFourDesktop/SearchFieldBar";
import { HeaderFourDesktopCont } from "./styled.styles";
interface IProps {
  onChangeQueryStringEvent?: (val: any, fieldName: string) => void; // to be used for listing
}

const HeaderDesktopFour: FC<IProps> = ({ onChangeQueryStringEvent = null }) => {
  return (
    <HeaderFourDesktopCont
      id="headerFourDesktop"
      className="width-1200 flex pt-16 pb-16 m-auto"
    >
      <SearchFieldBar onChangeQueryStringEvent={onChangeQueryStringEvent} />
    </HeaderFourDesktopCont>
  );
};

export default HeaderDesktopFour;
